import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const ADC_DAC_Interfacing = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="ADC & DAC Interfacing with 8051 Microcontroller"
      videos={[
        "https://www.youtube.com/embed/xsL4vxFMyaM", // Dr. Swapna Thouti's video on ADC interfacing
        "https://www.youtube.com/embed/2gY96Scgwj4", // Prof. Ravindra Chavan's video on DAC interfacing
      ]}
      takeaways={[
        {
          text: "Learn the theory part and remember the connection diagrams for both ADC and DAC interfacing.",
        },
        {
          text: "Questions typically come indirectly, often in the context of sensor applications.",
        },
        {
          text: "The basic code structure and algorithm remain consistent, but specific calculations may be required based on the application.",
        },
      ]}
      questions={[
        "Assume that a Temperature Sensor is interfaced to 8051 microcontroller to sense the temperature of the room. Design a block diagram and a circuit diagram to explain the interfacing of the mentioned sensor and its conditioning with 8051 microcontroller.",
        "Draw the diagram for interfacing 8051 with DAC 0808 at Port P1, develop 8051 assembly programs to generate (a) a stair-step ramp waveform and (b) a triangular waveform.",
        "Draw the block of the described system with the required control signals. A temperature sensor is connected to the analog input of an ADC, the 8-bit digital output lines of the ADC are connected to P1 of 8051 and the 8-bit input of the DAC is connected to P0 of 8051. Write 8051 ALP to continuously get the data (C) from the ADC output, compute F = (9*C)/5 + 32 and send the result (F) to input of the DAC.",
        "Draw the connection diagram of ADC 0804 to interface with the 8051 Microcontroller such that the data lines of ADC are connected to P1 of 8051, RD signal at P2.5, WR Signal at P2.6 and INTR signal at P2.7. Write an assembly language program for the above connection to get the digital output.",
      ]}
      exampleVideos={[]} // No extra example videos
    />
  );
}

export default ADC_DAC_Interfacing;
